import { ALLOWED } from "@/app/infrastructures/misc/RolePermission";
import { FlagsNetwork } from "@/feature-flags/flags-network";

const Layout = () =>
  import(/* webpackChunkName: "Layout" */ "@/app/ui/layout/index.vue");
const DetailCSV = () =>
  import(
    /* webpackChunkName: "Operational Area" */ "@/app/ui/views/route/operational-area/component/csv/detail-csv.vue"
  );
const DetailUrsa = () =>
  import(
    /* webpackChunkName: "Operational Area" */ "@/app/ui/views/route/operational-area/component/ursa/detail-ursa.vue"
  );

export default [
  {
    path: "/network/operational-area",
    component: Layout,
    name: "csv",
    meta: {
      hidden: true,
      parent: "Location",
      permission: FlagsNetwork.list_csv_detail
    },
    children: [
      {
        path: "csv/:id",
        name: "detail-location-csv",
        component: DetailCSV,
        meta: {
          header: true,
          title: "CSV | Detail"
        }
      }
    ]
  },
  {
    path: "/network/operational-area",
    component: Layout,
    name: "ursa",
    meta: {
      hidden: true,
      parent: "Location",
      permission: FlagsNetwork.list_ursa_code_detail
    },
    children: [
      {
        path: "ursa",
        name: "detail-location-ursa",
        component: DetailUrsa,
        meta: {
          header: true,
          title: "Ursa | Detail",
          newLayout: true
        }
      }
    ]
  }
];
